<template>
  <span class="pr prompt"><img src="@/assets/Icons/tip.png" alt=""><i :class="['line-sm font14 font-light', {active: isMany}]">{{text}}</i></span>
</template>

<script>

export default {
  props: {
	  // 提示文字
	  text: {
		type: String,
		default: '提示'
	  },
	  // 是否换行，适合多文字
	  isMany: {
		  type: Boolean,
		  default: false
	  }
  },
  data() {
    return {}
  }
}

</script>

<style lang="less">
	.prompt{
		&:hover i{
			display: block;
		}
		img{
			width: .16rem;
			margin-left: .1rem;
		}
		i{
			display: none;
			position: absolute;
			left: .3rem;
			top: 50%;
			transform: translateY(-50%);
			max-width: 2rem;
			background: rgba(0,0,0,.5);
			color: #fff;
			border-radius: 3px;
			padding: 5px;
			white-space: nowrap;
			&.active{
				width: 2rem;
				white-space: normal;
			}
		}
	}
</style>
